module.exports = __webpack_public_path__ + "img/67.1caf0412.jpg";